import IDialogProxyService from "./dialog_proxy_service_interface";
import {
    IDialogService,
    IModalDialogHandler, ISimpleTextModalOptions,
    ShowModalOptions
} from "../../../../app-react/services/dialog/dialog.service.interface";
import BaseService from "../../base/base_service";
import React from "react";

interface DialogProxyServiceParams {
    getDialogService: () => IDialogService;
}

export default class DialogProxyService extends BaseService implements IDialogProxyService {
    static CLASS = 'DialogProxyService';

    private _params: DialogProxyServiceParams;
    init(params: DialogProxyServiceParams) {
        super.init(params);
        this._params = params;
    }

    private get dialog(): IDialogService {
        return this._params.getDialogService();
    }
    showModal(renderContent: (dialogHandler: IModalDialogHandler) => React.ReactNode, options?: ShowModalOptions): IModalDialogHandler {
        return this.dialog.showModal(renderContent, options);
    }
    showSimpleTextModal(options: ISimpleTextModalOptions): IModalDialogHandler {
        return this.dialog.showSimpleTextModal(options);
    }

    get currentDialogs(): React.ReactNode[] {
       return this.dialog.currentDialogs;
    }
    get hasOpenDialogs(): boolean {
        return this.dialog.hasOpenDialogs;
    }
    getMaxCGPOverlayZIndex(): number {
        return this.dialog.getMaxCGPOverlayZIndex();
    }

    closeAllDialogs(): void {
        this.dialog.closeAllDialogs();
    }
    countDialogs(opts: {includeHidden: boolean;}): number {
        return this.dialog.countDialogs(opts);
    }

}